import React from 'react';

const Home = () => {
  return (
    <div className="container">
      <h2>Welcome to Eco-Community Hub</h2>
      <p>This platform aims to promote environmental awareness and sustainable living practices.</p>
      <p>Explore our tools such as the Carbon Footprint Calculator and curated Sustainability Tips.</p>
    </div>
  );
};

export default Home;
